import { IErrorLoggerWithUserSupport } from '@verv-inc/js-toolkit/core-logs/lib/ErrorLoggerWithUserSupport';

import { IEveryDoggyAPIServices } from '../../../../../../utils/services/EveryDoggyAPIServices';
import {
  IStripeViewModel,
  composeStripeCheckoutViewModel,
} from '../../../../../../utils/payments/stripeCheckoutViewModel';
import { GTMOnboardingFunnelEvent } from '../../../../../../utils/analytics';

export type { IStripeViewModel };

/** Chat-upsale checkout: success is tracked as `paymentSuccessfulChat`. */
function ComposeStripeViewModel(
  sourceURL: string,
  stripePlanID: string,
  apiServices: IEveryDoggyAPIServices,
  errorLogger: IErrorLoggerWithUserSupport,
  internalId: string
): IStripeViewModel {
  return composeStripeCheckoutViewModel(
    sourceURL,
    stripePlanID,
    apiServices,
    errorLogger,
    internalId,
    ({ productName, amount }) => GTMOnboardingFunnelEvent.paymentSuccessfulChat(productName, 'stripe', amount)
  );
}

export default ComposeStripeViewModel;
